module.exports = __webpack_public_path__ + "img/35_1.3785f3f2.png";